module.exports = __webpack_public_path__ + "static/media/e_kash.85cfc971.jpeg";